import { createBrowserRouter } from 'react-router-dom';

import App from './pages/App';
import RegistrationPage from './pages/RegistrationPage';
import LoginPage from './pages/LoginPage';
// import ForgotPasswordPage from './pages/ForgotPasswordPage';
// import ProtectedRoute from './components/ProtectedRoute';
import NotFoundPage from './pages/NotFoundPage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import NewsPage from './pages/NewsPage';
import FreePolicyPage from './pages/FreePolicyPage';
import PaidPolicyPage from './pages/PaidPolicyPage';
import SystemOverViewPage from './pages/SystemOverviewPage';
import DemoPage from './pages/DemoPage';
import TermsPage from './pages/TermsPage';
import AdminPage from './pages/AdminPage';

const router = createBrowserRouter([
    {
      path: "*",
      element: <NotFoundPage/>
    },
    {
        path: "/",
        element: <App/>
    },
    {
      path: "/register",
      element: <RegistrationPage/>
    },
    {
      path: "/login",
      element: <LoginPage/>
    },
    {
      path: "/contact-us",
      element: <ContactPage/>
    },
    {
      path: "/about-us",
      element: <AboutPage/>
    },
    {
      path: "/news",
      element: <NewsPage/>
    },
    {
      path: "/policies/free",
      element: <FreePolicyPage/>
    },
     {
      path: "/policies/paid",
      element: <PaidPolicyPage/>
    },
    {
      path: "/systems/overview",
      element: <SystemOverViewPage/>
    },
    {
      path: "/systems/demo",
      element: <DemoPage/>
    },
    {
      path: "/terms",
      element: <TermsPage/>
    },
    {
      path: "/ipsa_admin",
      element: <AdminPage/>
    }
  ])
  
  export default router